import React from "react";
import { softwareTrendsServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const SoftwareTrendsServiceDetailPage = () => {
  const data = softwareTrendsServiceData;
  return (
    <>
      <SEO {...seoData.softwareTrends} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default SoftwareTrendsServiceDetailPage;
